module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/hairstyle_01-109cdfb8b4b98cdb6a008c7df6d4121f.webp";